import {
  ConvertibleUnit,
  format,
  FormatOptions,
  Unit,
} from '@dynatrace-sdk/units';

import { defaultUnitFormatter } from './defaultUnitFormatter.js';
import { Formatter, isFormatterOptions } from '../types/formatter.js';

export function getFormatter(
  formatter?: Formatter | FormatOptions<Unit, ConvertibleUnit>,
): Formatter {
  if (!formatter) {
    return (value: number, unit?: string | Unit) =>
      defaultUnitFormatter(unit)(value);
  }

  if (isFormatterOptions(formatter)) {
    return (value: number) => format(value, formatter);
  }

  return formatter;
}
